module.exports = __webpack_public_path__ + "img/reward_leaf_black_L.6672b2b7.png";